import { Channel, Role, User } from "types";
import TextChannel from "./Text/Messages";
import TodoChannel from "./Todo/List";
import { useParams } from "react-router-dom";
import ApplicationsChannel from "./Application/Applications";
import WatchStreamChannel from "./WatchStream/Watch";
import VoiceChannelDisplay from "./Voice/Display";
import NSFWAlert from "./NSFW";
import { useQueryClient } from "@tanstack/react-query";

export default function ChannelCheck({ channel, socket, isNsfwAccepted, setIsNsfwAccepted }: { channel: Channel, socket: any, isNsfwAccepted?: any, setIsNsfwAccepted?: any }) {
    const { channelId,teamId } = useParams();
    document.title = `#${channel?.name || "Applications"} - Teamly`;
    const queryClient = useQueryClient();
    const roles = queryClient.getQueryState(["team", teamId, "roles"]) as any;
    const members = queryClient.getQueryState(["team", teamId, "members"]) as any;
    const me = queryClient.getQueryState(["team", teamId, "members", "@me"]) as any;
    const user = queryClient.getQueryState(["user"]) as any;
    
    if (channel?.nsfw && !isNsfwAccepted.includes(channel.id)) return <NSFWAlert setIsNsfwAccepted={setIsNsfwAccepted} channel={channel} />;
    return (
        <>
            <div className="sm:p-4 w-full sm:max-h-full flex sm:rounded-2xl z-30">
                {
                    channel?.type === "text" && channelId ? (
                        <TextChannel channel={channel}  />
                    ) : channel?.type === "todo" && channelId ? (
                        <TodoChannel channel={channel} socket={socket} />
                    ) : channelId === "applications" ? (
                        <ApplicationsChannel />
                    ) : channel?.type === "watchstream" ? (
                        <WatchStreamChannel channel={channel} me={me} socket={socket} />
                    ) : channel?.type === "voice" ? (
                        <VoiceChannelDisplay channel={channel} user={user} me={me} socket={socket} roles={roles} members={members} />
                    ) : null
                }
            </div>
        </>
    );
}